<template>
  <!-- 签到规则 -->
  <div class="signRule">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['签到管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)"
          >新增签到规则</el-button
        >
        <el-button type="danger" @click="handleDel()">删除</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="规则状态"
          style="width: 200px"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          style="width: 200px; margin: 0 5px"
          v-model="searchForm.name"
          clearable
          placeholder="输入编号/名称"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      @selection-change="selectionChange"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        type="selection"
        align="center"
        width="55">
      </el-table-column> -->
      <el-table-column
        align="center"
        prop="entName"
        show-overflow-tooltip
        label="机构名称"
      >
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="方案编号"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="方案名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="type"
        label="签到类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="userType"
        label="客户类型"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="addTime"
        label="创建日期"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="state"
        label="是否启用"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state == 2" type="success">已启用</el-tag>
          <el-tag v-else type="danger">未启用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            >编辑</el-button
          >
          <el-button
            v-if="scope.row.state == 1"
            type="success"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, '2')"
            >启用</el-button
          >
          <!-- <el-button
            v-if="scope.row.state == 1"
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="changeStatus(scope.row, '0')"
            >删除</el-button
          > -->
          <el-button
            type="warning"
            style="padding: 2px 3px"
            plain
            v-if="scope.row.state != 1"
            @click="changeStatus(scope.row, '1')"
            >禁用</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>该界面维护积分商城签到赠送积分规则</p>
        <p>使用场景：在App积分商城/PC积分商城签到赠送积分使用</p>
        <div>
          <p>操作说明：</p>
          <p>1、新增：新增签到规则</p>
          <p>2、编辑</p>
          <p>3、启用禁用</p>
        </div>
        <p>备注：必须先设置签到规则，否则用户签到不会赠送积分</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "signRule",
  data() {
    return {
      /**表格数据 */
      // {
      //   entName:"机构名称",
      //   id:"方案编号",
      //   name:"方案名称",
      //   type:"签到类型",
      //   userType:"客户类型",
      //   addTime: "创建日期",
      //   state: "状态",
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      searchForm: {
        status: "99",
        name: "",
      },
      options: [
        { label: "全部", value: "99" },
        { label: "已启用", value: "2" },
        { label: "已禁用", value: "1" },
      ],
      /**使用说明 */
      explain: false,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    /**获取表格数据 */
    getTableData() {
      let data = {
        type: "GetSign",
        status: this.searchForm.status,
        sqlWhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageIndex,
      };
      let proc = "Proc_SignLog"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        url:
          "SignLog/ashx/returnJson.ashx?type=" +
          type +
          "&Json=" +
          encodeURI(JSON.stringify(data)) +
          "&proc=" +
          proc,
        method: "Post",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.allPage = res.recordCount;
            this.tableData = res.data.map((item) => ({
              entName: item.entname,
              id: item.fabh,
              name: item.faName,
              type: item.faType,
              userType: item.clientName,
              addTime: item.addTime,
              state: item.status,
            }));
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    handleDel() {
      let row = {};
      if (this.selectedList.length == 1) {
        row = this.selectedList[0];
        this.changeStatus(row, 0);
      } else {
        this.$message({
          message: "只能删除一条数据",
          type: "warning",
        });
      }
    },
    changeStatus(row, status) {
      let msg = "确定要执行操作吗?";
      let type = "info";
      if (status == 1) {
        msg = "确定禁用吗?";
        type = "warning";
      } else if (status == 2) {
        msg = "确定启用吗?";
        type = "success";
      } else if (status == 0) {
        msg = "确定删除吗?";
        type = "error";
      }
      this.$confirm(msg, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            type: "UpdateSign",
            id: row.id,
            status: status,
          };
          let proc = "Proc_SignLog"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            url:
              "SignLog/ashx/returnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
            method: "post",
          })
            .then((res) => {
              if (res.flag == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    /**点击新增/编辑 */
    handleAdd(row) {
      let prams = null;
      if (row) {
        prams = encodeURIComponent(JSON.stringify({ id: row.id }));
      } else {
        prams = row;
      }
      this.$router.push({
        path: "signFun",
        query: {
          prams: prams,
        },
      });
      prams = null;
    },
  },
};
</script>

<style scoped>
.signRule {
  width: 100%;
  height: 100%;
}
</style>
